import FileDownload from "js-file-download";
import React, { useState } from "react";
import { modalActions } from "../../../context/actions/modalActions";
import useStore from "../../../context/useStore";
import downloadTools from "../../../helpers/useDownload";
import ApercuPdf from "../../common/ApercuPdf";

// Le type de courrier côté API (CourrierType.SUSPENSION_REMOBILISATION).
const TYPE_COURRIER = "SUSPENSION_REMOBILISATION";

/**
 * Ouvre le courrier envoyé à l'allocataire après une remobilisation validée
 * (CE-1335). Le parcours est le seul écran que tous les agents consultent : la
 * page de gestion des demandes est réservée au Directeur et à ses délégataires.
 *
 * L'API ne sert que le document conservé à l'envoi — ce courrier n'a ni aperçu
 * ni reconstitution. Tant qu'il n'est pas parti, elle répond 404, et
 * `useDownload` affiche son message à l'agent.
 */
const VoirCourrierRemobilisation = ({ demandeId }) => {
  const [state, dispatch] = useStore();
  const mActions = modalActions(state, dispatch);
  const [chargement, setChargement] = useState(false);

  const ouvrir = async () => {
    setChargement(true);
    try {
      const { blob, filename } = await downloadTools.fetchFile("courriers/generer", {
        entityId: demandeId,
        type: TYPE_COURRIER,
      });
      mActions.updateModal({
        isOpen: true,
        content: (
          <>
            <h5 className="mb-3">Courrier envoyé à l'allocataire</h5>
            <ApercuPdf blob={blob} titre="Courrier envoyé à l'allocataire" />
          </>
        ),
        actions: (
          <button className="btn btn-primary" onClick={() => FileDownload(blob, filename || "courrier-remobilisation.pdf")}>
            <i className="fa fa-download mr-2" aria-hidden="true" />
            Télécharger
          </button>
        ),
      });
    } catch (err) {
      // L'erreur est déjà signalée à l'agent par useDownload.
    } finally {
      setChargement(false);
    }
  };

  return (
    <button type="button" className="btn btn-link p-0 suspension-remobilisation__voir-courrier" onClick={ouvrir} disabled={chargement}>
      <i className={`fa ${chargement ? "fa-circle-notch fa-spin" : "fa-eye"} mr-1`} aria-hidden="true" />
      Voir le courrier envoyé
    </button>
  );
};

export default VoirCourrierRemobilisation;
